/**
 * Helpers to enter / leave fullscreen
 */

var Fullscreen = function() {

  let _element;

  /* View in fullscreen */
  function openFullscreen(el) {
    // console.log(`Fullscreen open()`, el);
    if (!document.fullscreen) {
      _element = el || document.documentElement;
      // console.log(`Fullscreen open()`, _element);
      if (_element.requestFullscreen) {
        _element.requestFullscreen();
      } else if (_element.mozRequestFullScreen) { /* Firefox */
        _element.mozRequestFullScreen();
      } else if (_element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        // console.log(`Request webkitRequestFullscreen() for `, _element);
        _element.webkitRequestFullscreen();
      } else if (_element.msRequestFullscreen) { /* IE/Edge */
        _element.msRequestFullscreen();
      }
    }
  }

  /* Close fullscreen */
  function closeFullscreen() {
    // console.log(`Fullscreen close()`);
    if (document.fullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    }
  }

  function switchFullscreen(el = null) {
    // console.log(`Fullscreen switch`);
    if (document.fullscreen) closeFullscreen();
    else openFullscreen(el);
  }

  function getElement() {
    return _element;
  }

	return {
    open: openFullscreen,
    close: closeFullscreen,
    switch: switchFullscreen,
    getElement
	}
};

export { Fullscreen as default };
